import { render } from "./AuthLayout.vue?vue&type=template&id=21c04387"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
script.render = render

export default script